// extracted by mini-css-extract-plugin
module.exports = {"scrollIndicator":"scroll-indicator_scrollIndicator__HDwMl","scrollArrow":"scroll-indicator_scrollArrow__9mUtt","bounce":"scroll-indicator_bounce__eyGtu"};